import React, { useState } from 'react';
import { Mail, MapPin, Send, CheckCircle } from 'lucide-react';
import { contactInfo } from '../data/mockData';
import '../styles/contact.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    program: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    
    // Reset after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        program: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-grid">
          {/* Left - Contact Info */}
          <div className="contact-info">
            <div className="section-label">
              <span>Get in Touch</span>
            </div>
            <h2 className="section-title">
              Start Your <span className="text-highlight">Cricket Journey</span>
            </h2>
            <p className="contact-description">
              Ready to elevate your game? Book a trial session and experience championship-level coaching firsthand.
            </p>
            
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <Mail size={24} />
                </div>
                <div className="contact-text">
                  <div className="contact-label">Email Us</div>
                  <a href={`mailto:${contactInfo.email}`} className="contact-value">{contactInfo.email}</a>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <MapPin size={24} />
                </div>
                <div className="contact-text">
                  <div className="contact-label">Visit Us</div>
                  <div className="contact-value">{contactInfo.address}</div>
                </div>
              </div>
            </div>
            
            <div className="trial-highlight">
              <CheckCircle size={20} />
              <span>Free trial session for new students!</span>
            </div>
          </div>

          {/* Right - Contact Form */}
          <div className="contact-form-wrapper">
            {isSubmitted ? (
              <div className="success-message">
                <CheckCircle size={64} />
                <h3>Thank You!</h3>
                <p>We've received your inquiry. Our team will contact you within 24 hours.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your name"
                  />
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="your@email.com"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phone">Phone *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="+91 98765 43210"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="program">Program Interest</label>
                  <select
                    id="program"
                    name="program"
                    value={formData.program}
                    onChange={handleChange}
                  >
                    <option value="">Select a program</option>
                    <option value="elite-batting">Elite Batting Academy</option>
                    <option value="wicket-keeping">Wicket-Keeping Masterclass</option>
                    <option value="junior">Junior Cricket Foundation</option>
                    <option value="match-prep">Match Preparation & Strategy</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Tell us about your cricket goals..."
                  ></textarea>
                </div>
                
                <button type="submit" className="submit-btn">
                  <Send size={20} />
                  Send Inquiry
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
